import * as React from 'react'

import DownloadIcon from '../../../components/icons/download'

interface IProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement | HTMLButtonElement> {
  iconClassName?: string
}

const DownloadButton = ({
  href,
  download,
  onClick,
  iconClassName = ''
}: IProps) => {
  return (
    <a download={download} role="button" href={href} onClick={onClick}>
      <DownloadIcon className={iconClassName} />
    </a>
  )
}

export default DownloadButton
